var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubble3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 42,
    viewBox: "0 0 151 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.11734 6.32983L2.16673 6.49241L2.10683 6.65142C1.71474 7.69218 1.5 8.82043 1.5 9.99999L1.5 32C1.5 37.2467 5.7533 41.5 11 41.5L141 41.5C146.247 41.5 150.5 37.2467 150.5 32V10C150.5 4.75329 146.247 0.499996 141 0.499996L11 0.499992C9.28701 0.499992 7.68132 0.952923 6.29455 1.74521L6.07917 1.86827L5.85088 1.77121C5.07695 1.44217 4.34016 1.07964 3.65883 0.712158C3.03445 0.375393 2.29452 0.460583 1.74608 0.822193C1.20384 1.17971 0.906166 1.76293 1.06084 2.41094C1.349 3.61813 1.70016 4.95649 2.11734 6.32983Z",
    fill: "current",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble3);
export default __webpack_public_path__ + "static/media/bubble3.b0447737dddeb98de5c8a2a59b4c8b59.svg";
export { ForwardRef as ReactComponent };